import { Stack, useTheme } from "@mui/material";
import { useOrganizationOverviewOneSsq } from "src/api/client-api/company/overview/useOrganizationOverviewOneSsq.tsx";
import { useParams } from "react-router";
import { useCompanyMetadata } from "src/context/Company/Metadata/useCompanyMetadata";
import { useFoodpilotContext } from "src/context/FoodpilotContext";
import { Loading } from "src/components/utils/Loading.tsx";
import { OneScoreOverview } from "src/pages/Company/MyCompany/OneScoreOverview/OneScoreOverview.tsx";
import { useEntityScores } from "src/context/Scores/useEntityScores";
import { ManyScoresOverview } from "./ManyScoresOverview/ManyScoresOverview";
import { useCompanyOverviewContext } from "src/context/Company/Overview/useCompanyOverviewContext";
import { MyPublications } from "src/components/Publications/MyPublications";

export const OneSsqOverview = () => {
    const theme = useTheme();
    const { currentCampaign } = useFoodpilotContext();
    const { company } = useCompanyMetadata();
    const { selectedVariations } = useEntityScores();
    const { filteredOverview } = useCompanyOverviewContext();
    const { ssqId } = useParams();

    // We want to get rid of this call, but for now, we cannot because
    // we need more information about the action plans in the Overview call.
    // Maybe other things as well, but we need to make the comparison
    // with :
    // const { filteredOverview } = useCompanyOverviewContext();
    // to know for sure

    const { overview, isReady } = useOrganizationOverviewOneSsq({
        campaignId: currentCampaign?.id,
        companyId: company.id,
        ssqId: ssqId,
        variations: selectedVariations.query,
    });

    if (!isReady && !overview) {
        return <Loading />;
    }

    const scoresOverview = overview?.scoresOverview?.["hydra:member"] ?? [];
    const ssqScoreId = scoresOverview.length > 0 ? scoresOverview[0]?.score?.id : undefined;

    return (
        <Stack flexDirection="column" gap={theme.spacing(4)}>
            {scoresOverview.length === 0 && <>{"No score available"}</>}
            {scoresOverview.length === 1 && <OneScoreOverview overview={scoresOverview[0]} isSingleScore={true} />}
            {scoresOverview.length > 1 && <ManyScoresOverview />}
            {typeof ssqScoreId === "number" && <MyPublications scoreIdsFilter={[ssqScoreId]} />}
        </Stack>
    );
};
